import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import {
  doCreateCarrier,
  doCreateCarrierIntegration,
  doGetCarrier,
  doGetCarrierIntegrations,
  doGetCarriers,
  doUpdateCarrier,
  doUpdateCarrierIntegration,
} from './thunk';

const isActionWithPending = (action) => {
  return action.type && action.type.startsWith('carriers/') && action.type.endsWith('/pending');
};

const isActionWithFulfilled = (action) => {
  return action.type && action.type.startsWith('carriers/') && action.type.endsWith('/fulfilled');
};

const isActionWithFailed = (action) => {
  return action.type && action.type.startsWith('carriers/') && action.type.endsWith('/rejected');
};

const carriersAdapter = createEntityAdapter({
  selectId: (item) => item.id,
});

const carrierIntegrationsAdapter = createEntityAdapter({
  selectId: (item) => item.id,
});

const initialState = carriersAdapter.getInitialState({
  action: null,
  isFetching: false,
  status: 'idle',
  carrier: undefined,
  carrierIntegrations: carrierIntegrationsAdapter.getInitialState(),
  carriers: carriersAdapter.getInitialState(),
});

const carriersSlice = createSlice({
  name: 'carrierIntegrations',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetCarrierIntegrations.pending, (state) => {
      (state.action = 'getall'), (state.status = 'loading');
    });
    builder.addCase(doGetCarrierIntegrations.fulfilled, (state, action) => {
      const { carrierIntegrations } = action.payload;
      state.status = 'succeeded';
      carrierIntegrationsAdapter.setAll(state.carrierIntegrations, carrierIntegrations);
    });
    builder.addCase(doGetCarrierIntegrations.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doGetCarrier.pending, (state) => {
      state.action = 'getOne';
      state.status = 'loading';
    });
    builder.addCase(doGetCarrier.fulfilled, (state, action) => {
      state.carrier = action.payload;
      state.status = 'succeeded';
    });
    builder.addCase(doGetCarrier.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doGetCarriers.pending, (state) => {
      (state.action = 'getall'), (state.status = 'loading');
    });
    builder.addCase(doGetCarriers.fulfilled, (state, action) => {
      const { carriers } = action.payload;
      state.status = 'succeeded';
      carriersAdapter.setAll(state.carriers, carriers);
    });
    builder.addCase(doGetCarriers.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doCreateCarrierIntegration.fulfilled, (state, action) => {
      carrierIntegrationsAdapter.upsertOne(state.carrierIntegrations, action.payload);
    });
    builder.addCase(doUpdateCarrierIntegration.fulfilled, (state, action) => {
      carrierIntegrationsAdapter.upsertOne(state.carrierIntegrations, action.payload);
    });
    builder.addCase(doCreateCarrier.pending, (state) => {
      state.action = 'create';
      state.status = 'loading';
    });
    builder.addCase(doCreateCarrier.fulfilled, (state, action) => {
      state.status = 'succeeded';
      carriersAdapter.upsertOne(state.carriers, action.payload);
    });
    builder.addCase(doCreateCarrier.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doUpdateCarrier.pending, (state) => {
      state.action = 'update';
      state.status = 'loading';
    });
    builder.addCase(doUpdateCarrier.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doUpdateCarrier.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addMatcher(isActionWithPending, (state) => {
      state.isFetching = true;
      state.message = null;
    });
    builder.addMatcher(isActionWithFulfilled, (state) => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, (state) => {
      state.isFetching = false;
      state.message = null;
    });
  },
});

export const { selectAll: selectAllCarrierIntegrations } = carriersAdapter.getSelectors(
  (state) => state.carriers.carrierIntegrations,
);

export const { selectAll: selectAllCarriers, selectById: selectCarrierById } = carriersAdapter.getSelectors(
  (state) => state.carriers.carriers,
);

const { reducer: carriersReducer } = carriersSlice;
export default carriersReducer;
